module.exports = __webpack_public_path__ + "img/assistant.cf7235fe.svg";